import { useNavigate, useParams } from 'react-router-dom';
import './oildetail.css';

const pickleData = {
  garlic: {
    name: 'Garlic Pickle',
    image: '/images/pickles/garlic.webp',
    description: 'Garlic Pickle, known as Poondu Oorugai (பூண்டு ஊறுகாய்) in Tamil, is a bold and aromatic South Indian pickle made by curing whole garlic pods in a blend of tamarind, red chilli powder, mustard seeds, and gingelly oil (nallennai). Popular in regions like Madurai, Trichy, and Karaikudi, this pickle is a staple in many Tamil homes. It is believed to boost immunity, aid digestion, and warm the body, especially during cooler seasons. Often served with curd rice, dosa, or idli, garlic pickle adds a spicy, tangy kick that transforms even the simplest meal into a flavorful experience rooted in Tamil culinary tradition.',
  },
  ginger: {
    name: 'Ginger Pickle',
    image: '/images/pickles/ginger.webp',
    description: 'Ginger Pickle, known as Inji Oorugai (இஞ்சி ஊறுகாய்) in Tamil, is made by marinating freshly chopped ginger in a tangy mix of tamarind, red chilli powder, jaggery, and gingelly oil. It is commonly prepared in Tamil homes, especially in regions like Kanyakumari, Madurai, and Thanjavur. Inji oorugai is valued for its digestive and anti-inflammatory properties. Tamil families believe it stimulates appetite, relieves nausea, and clears the digestive tract, making it a go-to side dish for idli, dosa, curd rice, and tiffin meals. It’s a perfect balance of spice, sweetness, and traditional wellness.',
  },
  onion: {
    name: 'Onion Pickle',
    image: '/images/pickles/onion.webp',
    description: 'Onion Pickle, known as Vengaya Oorugai (வெங்காய ஊறுகாய்) in Tamil, is made using small pearl onions (chinna vengayam) marinated in a tangy mix of tamarind, red chilli powder, fenugreek, and gingelly oil. Popular in Chettinad and southern Tamil Nadu, it’s known for its bold flavor and spicy-sweet balance. This pickle is commonly served with curd rice, dosa, or meals during festivals. It is believed to enhance digestion, balance body heat, and stimulate appetite. Loved for its unique taste and aromatic punch, Vengaya Oorugai is a cherished side dish in traditional Tamil kitchens.',
  },
  cutmango: {
    name: 'Cut Mango Pickle',
    image: '/images/pickles/mango.webp',
    description: 'Cut Mango Pickle, known as Kalandha Manga Oorugai (கலந்த மாங்காய் ஊறுகாய்) in Tamil, is made from fresh, unripe mangoes chopped into pieces and mixed with red chilli powder, mustard seeds, hing, salt, and gingelly oil. This spicy-tangy pickle is a staple in Tamil homes, especially during the summer mango season. Prepared across regions like Thanjavur, Salem, and Tirunelveli, it’s believed to enhance appetite, aid digestion, and provide a burst of flavor with even a simple meal. Served with curd rice, dosa, or sambar rice, this pickle captures the essence of Tamil taste and tradition in every bite.',
  },
  smallmango: {
    name: 'Small Mango Pickle',
    image: '/images/pickles/minimango.webp',
    description: 'Small Mango Pickle, known as Vadu Mangai Oorugai (வடுமாங்காய் ஊறுகாய்) in Tamil, is made using tender baby mangoes preserved whole in a spiced brine of rock salt, red chilli powder, turmeric, and mustard seeds. This classic pickle is a hallmark of Tamil summer kitchens, especially in regions like Tanjore, Madurai, and Salem. Prepared in large batches and stored for months, Vadu Mangai is cherished for its firm texture, tangy-spicy taste, and long shelf life. It is believed to aid digestion and add a zing of tradition to meals like curd rice, pongal, or upma. A true Tamil favorite passed down for generations.',
  },
  lemon: {
    name: 'Lemon Pickle',
    image: '/images/pickles/lemon.webp',
    description: 'Lemon Pickle, known as Elumichai Oorugai (எலுமிச்சை ஊறுகாய்) in Tamil, is made by curing fresh lemons with salt, red chilli powder, turmeric, and gingelly oil, sometimes enhanced with fenugreek and asafoetida. It’s a staple pickle in Tamil Nadu, especially in homes across Thanjavur, Salem, and Coimbatore. Elumichai oorugai is valued for its tangy taste and digestive benefits. It’s believed to stimulate appetite, cleanse the stomach, and provide vitamin C. Often served with curd rice, dosa, or even sambar sadam, this pickle brings a zesty punch and a touch of tradition to every Tamil meal.',
  }
};

const PickleDetail = () => {
  const { type } = useParams();
  const pickle = pickleData[type];
  const navigate = useNavigate();
  const goToProducts = () => {
        navigate('/pickles');
    };

  if (!pickle) return <h2>Pickle not found</h2>;

  return (
    <section
      className="sesame-section"
      style={{ backgroundImage: `url(${pickle.image})` }}
    >
      <div className="sesame-content">
        <div className="text-content">
          <button className='back-btn-viewmore' onClick={goToProducts}>⟵ Back to Pickles Products</button>
          <h2>{pickle.name}</h2>
          <p>{pickle.description}</p>
        </div>
        <div className="button-box">
          <button className="enquire-btn">ENQUIRE NOW</button>
        </div>
      </div>
    </section>
  );
};

export default PickleDetail;
